import { useAppSelector } from '@customer/store/hooks';
import { selectMapDataBySiteId } from '@customer/store/slices/mapSlice';
import { LatLngExpression } from 'leaflet';
import { useMemo } from 'react';

export interface MapViewData {
  centre: LatLngExpression;
  zoom: number;
}

export const latlngAustralia: LatLngExpression = [-26.391869671769022, 133.6376953125];

export const useMapLastPositionData = (): MapViewData => {
  const userData = useAppSelector(state => state.auth);
  const siteMapData = useAppSelector(state =>
    selectMapDataBySiteId(state, userData.currentSite?.id ?? ''),
  );

  const mapData = useMemo(() => {
    if (siteMapData) {
      const latlng: LatLngExpression = [siteMapData.centreLat, siteMapData.centreLon];

      return {
        centre: latlng,
        zoom: siteMapData.zoom,
      };
    }

    return {
      // Centre on Australia the first time the page loads.
      // TODO: Determine this from site-specific data
      centre: latlngAustralia,
      zoom: 5,
    };
  }, [siteMapData]);

  return mapData;
};
